<template>
  <div>
    <!--右侧内容-->
    <div class="class_add_top"><a class="back" @click="backQuestionList()">返回</a>添加考题</div>
    <div class="class_add_con">
      <table width="100%" border="0" cellspacing="0" cellpadding="0">
        <tr class="tita">
          <td class="left_td">考题信息</td>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td class="left_td pt30">标题：</td>
          <td class="pt20"><input type="text" v-model="params.title" class="put_495" style=" width:395px;"/></td>
        </tr>
        <tr>
          <td class="left_td pt30">试题类型：</td>
          <td class="pt20"><li class="sea_on">简答题</li></td>
        </tr>
        <tr>
          <td class="left_td pt30">所属分类：</td>
          <td class="pt20">
            <select name="select" v-model="params.largeType" class="all_select" @change="getMiddleTypes(params.largeType)">
              <option v-for='item in largeTypes' :key="item.value" :value="item.value">{{item.label}}</option>
            </select>
            <select name="select" v-model="params.middleType" class="all_select">
              <option v-for='item in middleTypes' :key="item.middleType" :value="item.middleType">{{item.middleTypeLabel}}</option>
            </select>
          </td>
        </tr>
        <tr>
          <td class="left_td"></td>
          <td>
            <p>没有合适的分类？您可以<router-link :to="{path: prefix + '/org/examQClassification_f/' + $utils.URLencode(this.$route.fullPath) + '/' + this.$route.params.id}" class="routerLink">添加新分类</router-link></p>
          </td>
        </tr>
        <tr>
          <td class="left_td pt30">难易度：</td>
          <td class="pt20">
            <select name="select" v-model="params.level" class="all_select">
              <option v-for='item in Dropdown.state.level' :key="item.value" :value="item.value">{{item.label}}</option>
            </select>
          </td>
        </tr>
        <tr>
          <td class="left_td pt20" valign="top">试题题干：</td>
          <td class="pt10"><textarea v-model="params.questionInfoText" name="" cols="" rows=""  class="text_area"></textarea></td>
        </tr>
        <tr>
          <td class="left_td pt20" valign="top">问题资源地址：</td>
          <td class="pt10"><UploadOSS :uploadOSSConf="uploadOSSConf" :DOM_ID="'questionInfoUrl'" v-if="uploadOSSConf.STS!=null"  @success = "OSSUploadSuccess"></UploadOSS><input id="questionUri" v-model="params.questionInfoUrl"  name="questionUri" class="put_495" type="text" style="width:230px; margin-left:10px;" value="" maxlength="255" readonly></td>
        </tr>
        <tr>
          <td class="left_td pt20" valign="top">解题思路：</td>
          <td class="pt10"><textarea v-model="params.thinkingInfoText" name="" cols="" rows=""  class="text_area"></textarea></td>
        </tr>
        <tr>
          <td class="left_td pt20" valign="top">解题思路地址：</td>
          <td class="pt10"><UploadOSS :uploadOSSConf="uploadOSSConf" :DOM_ID="'thinkingInfoUrl'" v-if="uploadOSSConf.STS!=null"  @success = "OSSUploadSuccess"></UploadOSS><input id="questionUri6" v-model="params.thinkingInfoUrl" name="questionUri6" class="put_495" type="text" style="width:260px; margin-left:10px;" value="" maxlength="255" readonly></td>
        </tr>
        <tr>
          <td class="left_td pt20" valign="top">试题信息：</td>
          <td class="pt10"><textarea v-model="params.description" name="" cols="" rows=""  class="text_area"></textarea></td>
        </tr>
      </table>
      <p class="btn_center">
        <input name="" type="button" class="all_btn" @click="editQuestion()" value="保存提交" />
      </p>
    </div>
    <!--/右侧内容-->
  </div>
</template>
<script>

  import Dropdown from '@/store/modules/dropdowns'
  import UploadOSS from '@/components/common/upload/uploadOSS.vue'

  export default {
    components: { UploadOSS },
    data () {
      return {
        Dropdown: Dropdown,
        pages: 0,
        params: {
          title: '',
          questionType: 'short',
          answerInfo: '',
          description: '',
          largeType: '',
          level: '',
          middleType: '',
          questionInfo: '',
          thinkingInfo: '',
          questionInfoText: '',
          questionInfoUrl: '',
          thinkingInfoText: '',
          thinkingInfoUrl: ''
        },
        largeTypes: [],
        middleTypes: [],
        prefix: this.$route.meta.prefix || '',
        uploadOSSConf: { showMode: '2', style: 'img_upload', typeArr: 'image/png,image/jpg,image/jpeg', catalog: 'byl', fileName: '', maxSize: '2000000', STS: null }
      }
    },
    created () {
      if (this.$route.params.id === 'create') {
        this.params = {
          title: '',
          questionType: 'short',
          answerInfo: '',
          description: '',
          largeType: '',
          level: '',
          middleType: '',
          questionInfo: '',
          thinkingInfo: '',
          questionInfoText: '',
          questionInfoUrl: '',
          thinkingInfoText: '',
          thinkingInfoUrl: ''
        }
      } else {
        this.getQuestion(this.$route.params.id)
      }
      this.getLargeTypes()
    },
    mounted () {
      this.$nextTick(() => {})
      this.getSTS()
    },
    computed: {},
    methods: {
      OSSUploadSuccess (r) {
        if (r && r != '') {
          this.$set(this.params, r.dom_id, r.res.requestUrls[0])
        }
      },
      getLargeTypes () {
        this.$api.post(this.$global.examApiPath, '/dict/get', {type: 'examLargeType'}, r => {
          this.largeTypes = r.data
        })
      },
      getMiddleTypes (largeType) {
        this.$api.post(this.$global.examApiPath, '/examTypeRel/search', {largeType: largeType,  middleType: 'examMiddleType', select: '1'}, r => {
          this.middleTypes = r.data
        })
      },
      getQuestion (id) {
        this.$api.post(this.$global.examApiPath, '/examQuestion/get', {id: id}, r => {
          this.params = r.data
          this.$set(this.params, 'questionInfoText', this.$utils.dealQInfoNull(this.params.questionInfoList.description))
          this.$set(this.params, 'questionInfoUrl', this.$utils.dealQInfoNull(this.params.questionInfoList.uri))
          this.$set(this.params, 'thinkingInfoText', this.$utils.dealQInfoNull(this.params.thinkingInfoList.description))
          this.$set(this.params, 'thinkingInfoUrl', this.$utils.dealQInfoNull(this.params.thinkingInfoList.uri))
          this.getMiddleTypes(this.params.largeType)
        })
      },
      editQuestion () {
        this.params.questionInfo = this.params.questionInfoText + '|' + this.params.questionInfoUrl
        this.params.thinkingInfo = this.params.thinkingInfoText + '|' + this.params.thinkingInfoUrl
        this.$api.post(this.$global.examApiPath, '/examQuestion/save', this.params, r => {
          if (this.$route.params.id == 'create') {
            this.$toasted.show('试题创建成功！', {
              duration: 1000
            })
            this.$router.push({path: this.prefix + '/org/examQuestionList'})
          } else {
            this.$toasted.show('试题修改成功！', {
              duration: 1000
            })
          }
          this.$router.push({path: this.prefix + '/org/examQuestionList'})
        })
      },
      backQuestionList() {
        this.$router.push({path: this.prefix + '/org/examQuestionList'})
      },
      getSTS () {
        this.$api.get(this.$global.resourceApiPath, '/common/getSTS', {}, r => {
          let STS = [r.data.expiration, r.data.accessKeyId, r.data.accessKeySecret, r.data.securityToken, r.data.endpointClean, r.data.bucket, r.data.region]
          this.uploadOSSConf.STS = STS
        })
      }
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/org/examination_question/model_shortAnswer.vue